export class FormatFieldName {
    formatFieldName(champ: string): string {
        switch (champ) {
          case 'id': return 'Identifiant';
          case 'annee_id': return 'Identifiant annee';
          case 'competence_id': return 'Identifiant competence';
          case 'emploi_id': return 'Identifiant emploi';
          case 'niveau_requis_id': return 'Identifiant niveau requis';
          case 'action': return 'Action';      
          case 'min': return 'Min';      
          case 'max': return 'Max';      
          case 'libelle': return 'Libelle';      
          case 'adresse': return 'Adresse';
          case 'campagne_id': return 'Identifiant de la campagne';
          case 'code': return 'Code';
          case 'created_at': return 'Date de création';
          case 'data': return 'Data';
          case 'date_debut': return 'Date de début';
          case 'date_fin': return 'Date de fin';
          case 'date_heure': return 'date_heure';
          case 'date_jour': return 'date_jour';
          case 'description': return 'Description';
          case 'label': return 'Label';
          case 'matricule': return 'Matricule';
          case 'message': return 'Message';
          case 'model_id': return 'identifiant du Modele';
          case 'modele': return 'Modele';
          case 'module': return 'Module';
          case 'nom': return 'Nom';
          case 'operation': return 'Opération';
          case 'prenoms': return 'Prenoms';
          case 'profil_id': return 'Identifiant Profile';
          case 'sous_module': return 'Sous Module';
          case 'statut': return 'Statut';
          case 'type': return 'Type';
          case 'updated_at': return 'Date de mise à jour';
          case 'user_id': return 'Identifiant Utilisateur';
          default: return champ;
        }
    }
  }
  